var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';


const MarkdownPropertyIcon = ({ className }) => /*#__PURE__*/
_jsx("svg", {
  className: className || '',
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "1 2 22 20" }, void 0, /*#__PURE__*/

_jsx("g", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }, void 0, /*#__PURE__*/
_jsx("path", { d: "m8 21h12a2 2 0 0 0 2-2v-2h-12v2a2 2 0 0 1 -2 2zm0 0a2 2 0 0 1 -2-2v-14a2 2 0 1 0 -4 0v3h4" }), /*#__PURE__*/
_jsx("path", { d: "m19 17v-12a2 2 0 0 0 -2-2h-13m11 5h-5m5 4h-5" })
)
);


export { MarkdownPropertyIcon };